window.DressTheme={
 get routes(){return JSON.parse(document.getElementById('ThemeRoutes').textContent);},
 openDialog(d){if(!d||d.open)return;d._trigger=document.activeElement;d.showModal();document.documentElement.classList.add('dialog-open');},
 closeDialog(d){if(!d)return;d.close();if(!document.querySelector('dialog[open]'))document.documentElement.classList.remove('dialog-open');d._trigger?.focus();}
};
document.addEventListener('click',e=>{const open=e.target.closest('[data-open-dialog]');if(open)window.DressTheme.openDialog(document.getElementById(open.dataset.openDialog));const close=e.target.closest('[data-close-dialog]');if(close)window.DressTheme.closeDialog(close.closest('dialog'));});
document.addEventListener('cancel',e=>{if(e.target.matches('dialog:not(.facet-drawer)')){e.preventDefault();window.DressTheme.closeDialog(e.target);}},true);
class ThemeSlideshow extends HTMLElement{
 connectedCallback(){this.slides=[...this.querySelectorAll('[data-slide]')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.onclick=e=>{if(e.target.closest('[data-next]'))this.show(this.index+1);if(e.target.closest('[data-prev]'))this.show(this.index-1);if(e.target.closest('[data-go]'))this.show(Number(e.target.closest('[data-go]').dataset.go));if(e.target.closest('[data-pause]')){this.paused=!this.paused;e.target.textContent=this.paused?'Play':'Pause';}};this.show(0);this.querySelector('[data-pause]')?.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');if(this.paused&&this.querySelector('[data-pause]'))this.querySelector('[data-pause]').textContent='Play';this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.matches(':focus-within'))this.show(this.index+1);},Number(this.dataset.interval)||5000);}
 show(n){if(!this.slides.length)return;this.index=(n+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>{s.hidden=i!==this.index;s.setAttribute('aria-hidden',String(i!==this.index));});this.querySelectorAll('[data-go]').forEach(d=>d.setAttribute('aria-pressed',String(Number(d.dataset.go)===this.index)));const count=this.querySelector('[data-slide-count]');if(count)count.textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');}
 disconnectedCallback(){clearInterval(this.timer);}
}
customElements.define('theme-slideshow',ThemeSlideshow);
function syncFooter(root=document){root.querySelectorAll('.footer-group').forEach(d=>d.open=innerWidth>900);}
document.addEventListener('DOMContentLoaded',()=>syncFooter());
document.addEventListener('shopify:section:load',e=>syncFooter(e.target));
matchMedia('(min-width:901px)').addEventListener('change',()=>syncFooter());

document.addEventListener('click',e=>{const control=e.target.closest('[data-scroll]');if(control){const track=control.closest('[data-scroll-region]')?.querySelector('[data-scroll-track]');track?.scrollBy({left:Number(control.dataset.scroll)*Math.min(track.clientWidth*.8,600),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}});
document.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-slide]');const carousel=slide?.closest('theme-slideshow');if(carousel){carousel.paused=true;carousel.show(carousel.slides.indexOf(slide));const button=carousel.querySelector('[data-pause]');if(button)button.textContent='Play';}});


/* Desktop navigation hover and keyboard behavior — 2026-09-20 */
function initNavigation(root=document){
  const desktopQuery=matchMedia('(min-width:901px)');
  root.querySelectorAll('[data-desktop-navigation] details[data-nav-disclosure]').forEach(group=>{
    if(group.dataset.navigationReady)return;
    group.dataset.navigationReady='true';
    const summary=group.querySelector(':scope > summary');
    let closeTimer;
    const closeLater=()=>{
      clearTimeout(closeTimer);
      closeTimer=setTimeout(()=>{
        if(desktopQuery.matches&&!group.matches(':hover')&&!group.contains(document.activeElement))group.open=false;
      },180);
    };
    const openGroup=()=>{
      if(!desktopQuery.matches)return;
      clearTimeout(closeTimer);
      if(group.classList.contains('nav-group')){
        group.parentElement?.querySelectorAll(':scope > details.nav-group[open]').forEach(other=>{if(other!==group)other.open=false;});
      }
      group.open=true;
    };
    group.addEventListener('pointerenter',openGroup);
    group.addEventListener('pointerleave',closeLater);
    group.addEventListener('focusin',openGroup);
    group.addEventListener('focusout',closeLater);
    summary?.addEventListener('click',event=>{
      if(!desktopQuery.matches)return;
      event.preventDefault();
      openGroup();
    });
    summary?.addEventListener('keydown',event=>{
      if(!desktopQuery.matches)return;
      if(event.key==='ArrowDown'){
        event.preventDefault();
        openGroup();
        group.querySelector(':scope > .nav-children a, :scope > .nav-children summary')?.focus();
      }
    });
    group.addEventListener('keydown',event=>{
      if(!desktopQuery.matches||event.key!=='Escape')return;
      event.preventDefault();
      event.stopPropagation();
      group.open=false;
      summary?.focus();
    });
  });
}
document.addEventListener('DOMContentLoaded',()=>initNavigation());
document.addEventListener('shopify:section:load',event=>initNavigation(event.target));
matchMedia('(max-width:900px)').addEventListener('change',event=>{
  if(event.matches)document.querySelectorAll('[data-desktop-navigation] details[open]').forEach(group=>group.open=false);
});
